import useAppMutation from '../../../hooks/useAppMutation';
import IntegrationsAPI from '../../../services/IntegrationsAPI';
import {
  RequestPremiumDbsEditorLinkPayload,
  RequestPremiumDbsEditorLinkResponse,
} from './AgencySettingsDbs.types';

const useRequestPremiumDbsEditorLink = () => {
  return useAppMutation((payload: RequestPremiumDbsEditorLinkPayload) => {
    return IntegrationsAPI.post<RequestPremiumDbsEditorLinkResponse>(
      '/api/internal/edbs/editor-access',
      payload,
    );
  });
};

export default useRequestPremiumDbsEditorLink;
